
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1201_DtDialog extends Serenity.Extensions.GridEditorDialog<Report_1201_DtRow> {
        protected getFormKey() { return Report_1201_DtForm.formKey; }
        // protected getIdProperty() { return Report_1201_DtRow.idProperty; }
        protected getLocalTextPrefix() { return Report_1201_DtRow.localTextPrefix; }
        protected getNameProperty() { return Report_1201_DtRow.nameProperty; }
        // protected getService() { return Report_1201_DtService.baseUrl; }
        // protected getDeletePermission() { return Report_1201_DtRow.deletePermission; }
        // protected getInsertPermission() { return Report_1201_DtRow.insertPermission; }
        // protected getUpdatePermission() { return Report_1201_DtRow.updatePermission; }

        protected form = new Report_1201_DtForm(this.idPrefix);

    }
}